/**
 * Temporary frontend session (10 min) via cookie — no backend.
 * Session is created when the user visits the homepage.
 */

export const SESSION_COOKIE_NAME = "pulpit_fe_session"
export const SESSION_MAX_AGE_SEC = 600 // 10 minutes
export const SESSION_EXPIRED_REJECT = "SESSION_EXPIRED"
export const SESSION_EXPIRED_TOAST = "Your session has expired"

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

function getCookie(name) {
  if (typeof document === "undefined") return null
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${escapeRegExp(name)}=([^;]*)`)
  )
  return match ? decodeURIComponent(match[1].trim()) : null
}

/**
 * Create / refresh session cookie (call on homepage).
 */
export function setSessionCookie() {
  if (typeof document === "undefined") return
  document.cookie = `${SESSION_COOKIE_NAME}=1; Max-Age=${SESSION_MAX_AGE_SEC}; Path=/; SameSite=Lax`
}

/**
 * Returns true if session cookie exists and is not empty (browser enforces Max-Age).
 */
export function checkSession() {
  const v = getCookie(SESSION_COOKIE_NAME)
  return v != null && v !== ""
}

export function clearSessionCookie() {
  if (typeof document === "undefined") return
  document.cookie = `${SESSION_COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax`
}
